import StoreSidebar from './sidebar.js';
import CreateView from './new.js';
import PinpadQueriesNew from '../pinpad_queries/new.js';
import WarnHierarchyLevel from './warnHierarchyLevel.js';
import Content from '../../content.js';

var PaymentConfigView = getModule('IO.Views.Stores.PaymentConfig'), // eslint-disable-line one-var
  PaymentDevicesIndexView = getModule('IO.Views.PaymentDevices.Index'),
  Show = Content.extend({
    dom: {
      DCC_FUNCTIONALITY_ENABLED:
        '#store_payment_server_config_attributes_dcc_functionality_enabled',
      DCC_FUNCTIONALITY_VALUE:
        '#store_payment_server_config_attributes_dcc_functionality_value',
      PAYMENT_CONFIG_AJB: '.store-payment-config-ajb',
      PAYMENT_CONFIG_ESOCKET: '.store-payment-config-esocket',
      PAYMENT_CONFIG_ENGAGE: '.store-payment-config-engage',
      PINCOMM_PROMPT:
        '#store_payment_server_config_attributes_pincomm_prompt_debit',
      UBL_LCR_THRESHOLD:
        '#store_payment_server_config_attributes_ubl_lcr_threshold',
      PAYMENT_DEVICES: '.store-payment-devices',
      STORE_DETAILS: '.store-form',
      TABS: '.tabs',
      PREVIEW_FILE: '#preview-file',
      IMPORT_BTN: '#import-xml-btn',
      IMPORT_CONTAINER: '#import-xml-file',
      IMPORT_FORM: '#import-xml-form',
      SELECTS: '.select2select',
      DELETE_BUTTON: '.rpm-form-action-delete .alert.button',
      SAVE_BUTTON: '.io-form-action-save',
    },

    /*
        PUBLIC FUNCTIONS
      */
    beforeRender: function () {
      var storeId = $("[name='store_id']").val();

      this.sidebar = new StoreSidebar(storeId);
      this.pinpadQueries = new PinpadQueriesNew();
    },

    events: function () {
      var events = {};

      events['tabChange ' + this.dom.TABS] = '_refreshDropdownButton';
      events['change ' + this.dom.DCC_FUNCTIONALITY_ENABLED] =
        '_dccFunctionalityEnabledChanged';
      events['click ' + this.dom.DELETE_BUTTON] = '_warnStoreImpact';
      events['submit ' + this.dom.STORE_DETAILS] = '_beforeSave';
      return events;
    },

    onDestroy: function () {
      this.sidebar.destroy();
      this.paymentConfigAjb.destroy();
      this.paymentConfigEsocket.destroy();
      this.paymentConfigEngage.destroy();
      this.detailsView.destroy();
      this.paymentDevices.destroy();
    },

    render: function () {
      this.detailsView = new CreateView({ el: this.dom.STORE_DETAILS });
      this.paymentConfigAjb = new PaymentConfigView({
        el: this.dom.PAYMENT_CONFIG_AJB,
      });
      this.paymentConfigEsocket = new PaymentConfigView({
        el: this.dom.PAYMENT_CONFIG_ESOCKET,
      });
      this.paymentConfigEngage = new PaymentConfigView({
        el: this.dom.PAYMENT_CONFIG_ENGAGE,
      });
      this.paymentDevices = new PaymentDevicesIndexView({
        el: this.dom.PAYMENT_DEVICES,
      });

      $(this.dom.PINCOMM_PROMPT).on(
        'change',
        { dom: this.dom },
        this._updateUblTreshold,
      );

      $(this.dom.IMPORT_BTN).on(
        'click',
        { dom: this.dom },
        this._validateFileContent.bind(this),
      );
      this.$el.find(this.dom.SELECTS).select2();
    },

    _warnStoreImpact: function (e) {
      var warnModal,
        url = e.target.href + '/impact';

      if (!$(e.target).hasClass('triggered')) {
        e.preventDefault();

        warnModal = new IO.Views.Components.ConfirmationDialog({
          url: url,
          jst_template: 'stores/impacted', // eslint-disable-line camelcase
          method: 'GET',
        });
        warnModal.impact();
        warnModal.answer(function (proceed) {
          if (proceed) {
            $(e.target).addClass('triggered').trigger('click');
          }
          warnModal.destroy();
        });
        return false;
      }
    },

    _dccFunctionalityEnabledChanged: function (e) {
      if (e.currentTarget.value === 'true') {
        $(this.dom.DCC_FUNCTIONALITY_VALUE).show();
      } else {
        $(this.dom.DCC_FUNCTIONALITY_VALUE).hide();
      }
    },

    _showConfirmModal: function (filename, callback) {
      var storeId = $("[name='store_id']").val(),
        warnModal;

      warnModal = new IO.Views.Components.ConfirmationDialog({
        url: `/${currentCustomer}/store_template_impact?filename=${filename}&import=true&store_id=${storeId}`,
        jst_template: 'stores/templates/impacted',
        method: 'GET',
        modalWidth: 640,
      });
      warnModal.impact();
      warnModal.answer(function (proceed) {
        if (proceed) {
          callback();
        }
        warnModal.destroy();
      });
    },

    _validateFileContent: function (e) {
      var tagElementRegex = /{{[ ]?(\w+.?)+[ ]?}}/,
        file = $(e.data.dom.IMPORT_CONTAINER)[0].files[0],
        reader = new FileReader(),
        answer;

      e.target.blur();

      if (file) {
        e.preventDefault();

        this._showConfirmModal(file.name, () => {
          reader.onloadend = function (event) {
            if (event.target.result.match(tagElementRegex) === null) {
              answer = confirm(
                'This file does not contain variables tags. Are you sure you would like to proceed?',
              );
              if (answer === true) {
                $(e.data.dom.IMPORT_FORM)[0].submit();
              }
            } else {
              $(e.data.dom.IMPORT_FORM)[0].submit();
            }
          };

          reader.readAsText(file);
        });
      }
    },

    _refreshDropdownButton: function (e) {
      this._refreshedButton =
        !this._refreshedButton &&
        $(e.target).children().text() === 'Payment Devices';
    },

    _updateUblTreshold: function (e) {
      var pincomm = $(e.data.dom.PINCOMM_PROMPT),
        lcrThreshold = $(e.data.dom.UBL_LCR_THRESHOLD);

      if (pincomm.val() === 'true') {
        lcrThreshold.prop('readOnly', false);
        lcrThreshold.val('0500');
        lcrThreshold.prop('readOnly', true);
      } else if (pincomm.val() === 'false') {
        lcrThreshold.prop('readOnly', false);
        lcrThreshold.val('5000000');
        lcrThreshold.prop('readOnly', true);
      } else {
        lcrThreshold.prop('readOnly', false);
      }
    },

    _beforeSave: function () {
      if (!$(this.dom.STORE_DETAILS).hasClass('hierarchy-impact-yes')) {
        new WarnHierarchyLevel(
          this.dom.STORE_DETAILS,
          this.$el.find('.HierchyNodeSelectorContainer input').val(),
        );
        return false;
      }
      return true;
    },
  });

module.exports = Show;
